<template>
  <div id="box">
    <div class="back" v-on:click="back">
      <img src="../assets/GoBack.png" alt />
    </div>
    <div class="searchBox">
      <div class="search">
        <img src="../assets/search.png" alt />
        <input type="text" id="searchBox" placeholder="输入店铺名称" />
      </div>
      <div class="clickSearch" v-on:click="clickSearch">搜索</div>
    </div>
    <div v-for="(item,index) in shopList" :key="index">
      <div class="shopName" v-on:click="toShopIndex(item)">
        <div class="shopImg">
          <img :src="CShttp+item.shop_icon_image" alt />
        </div>
        <div class="Name">
          <div class="NameText">{{item.name}}</div>
          <div class="shopInfo">
            <div>
              <span>{{item.shop_class_list}}</span>
              <span class="shopInfoCenter">|</span>
              <span>月销量{{item.xiaoliang?item.xiaoliang:0}}</span>
            </div>
            <div>{{(item.juli/1000).toFixed(2)}}km</div>
          </div>
        </div>
      </div>
      <div class="swiperBox">
        <swiper :options="swiperOption">
          <swiper-slide v-for="(coupon,idxs) in item.coupon_list" :key="idxs">
            <div class="swiperTicket">
              <div class="ticketMoney" v-if="coupon.category=='免费券'&&coupon.name!=''">
                <span></span>
                <span>免</span>
              </div>
              <div class="ticketMoney" v-else>
                <span>￥</span>
                <span>{{coupon.amount}}</span>
              </div>
              <div class="useMust">{{coupon.use_rule}}</div>
              <div class="ticketType">{{coupon.category}}</div>
              <div class="ticketClick" v-on:click="ticketClick(coupon)">点击领取</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div class="noShop" v-if="shopList.length==0">暂无此商家信息</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import $ from "jquery";
export default {
  name: "",
  data() {
    return {
      shopList: [],
      CShttp: this.$store.state.CShttp,
      //swiper左右滑动
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        // loop:true,
        speed: 600 //config参数同swiper4,与官网一致
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {},
  mounted() {
    var openid = localStorage.getItem("ZQopenid");
    var UserInfo = localStorage.getItem("ZQUserInfo")
      ? JSON.parse(localStorage.getItem("ZQUserInfo"))
      : "";
    var location = JSON.parse(localStorage.getItem("ZQlocation"));
    this.$store.commit("location", location);
    this.$store.commit("UserInfo", {
      UserInfo: UserInfo
    });
     this.$store.commit("UserSelf", JSON.parse(localStorage.getItem("ZQUserSelf")));
    this.UserInfo = UserInfo;
    this.openid = UserInfo.openid;
    $("#searchBox").focus();
    $("#searchBox").val(this.$store.state.SearchValue?this.$store.state.SearchValue:this.$route.query.value);
    this.clickSearch();
  },
  methods: {
    //点击搜索商店
    clickSearch() {
       this.$store.commit("SearchValue", {
          SearchValue:  $("#searchBox").val(),
        });
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/shop/search_shop", {
            params: {
              name: $("#searchBox").val(),
              log: this.$store.state.log,
              lat: this.$store.state.lat
            }
          })
          .then(res => {
            if (res.data.code == 1) {
              console.log(res.data);
              var shop = res.data.data.action;
              this.shopList = [];
              shop.map(item => {
                this.shopList.push(item);
              });
              this.$store.commit("showLoading", false); //关闭加载图标
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
            }
          });
      }
    },
    //领取优惠券
    ticketClick(item) {
      if (!this.$store.state.loading) {
        this.$store.commit("showLoading", true); //显示加载图标
        this.$http
          .get("/api/coupon/receive", {
            params: {
              uid: this.$store.state.useId,
              shop_id: item.shop_id,
              coupon_id: item.id
            }
          })
          .then(res => {
            if (res.data.code == 1) {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", { show: true, type: true }); //显示领取成功
            } else {
              this.$store.commit("showLoading", false); //关闭加载图标
              this.$store.commit("showMsg", {
                show: true,
                type: false,
                msg: res.data.msg
              }); //显示领取失败
            }
          });
      }
    },
    back() {
      this.$router.go(-1);
    },
    //跳转商品详情页
    toShopIndex(item) {
      this.$router.push({ path: "/shopIndex", query: { id: item.id } });
    }
  }
};
</script>
<style lang='scss' scoped>
#box {
  width: 100%;
  background: white;
  // height: 90%;
  // overflow: scroll;
  background-repeat: no-repeat;
  background-size: 100% 2.3rem;
  display: inline-block;
}
.back {
  position: absolute;
  top: 0.5rem;
  left: 0.2rem;
  width: 0.4rem;
  height: 0.4rem;
  z-index: 1000;
}
.back img {
  width: 100%;
  height: 100%;
  display: inline-block;
}
.searchBox {
  height: 0.8rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #e22319;
  background: white;
  opacity: 0.9;
  border-radius: 0.4rem;
  padding-left: 0.3rem;
  font-size: 0.24rem;
  margin: 0.3rem 0.3rem 0.23rem 0.9rem;
}
.search {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.searchBox img {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  margin-right: 0.2rem;
}
.searchBox input {
  border: none;
  outline: none;
  -webkit-appearance: none;
}
.clickSearch {
  width: 1.9rem;
  height: 100%;
  background-image: linear-gradient(to right, #e73d35, #bc170f);
  opacity: 1;
  color: white;
  font-size: 0.32rem;
  border-radius: 0.4rem;
  text-align: center;
  line-height: 0.8rem;
}
.shopName {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 0.3rem;
  padding-top: 0.1rem;
}
.backShow {
  width: 100%;
  height: 2.3rem;
  //   background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.5));
  position: absolute;
  left: 0;
  top: 0;
}
.shopName > .shopImg {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;
  z-index: 100;
}
.shopImg > img {
  width: 1.2rem;
  height: 1.2rem;
  flex-shrink: 0;
}
.Name {
  width: 100%;
  margin-left: 0.3rem;
  margin-top: 0.2rem;
  position: relative;
}
.NameText {
  font-size: 0.28rem;
  line-height: 0.4rem;
  font-weight: 700;
}
.shopInfo {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.24rem;
  color: #636363;
  height: 0.6rem;
}
.shopInfoCenter {
  display: inline-block;
  margin: 0 0.2rem;
}
.swiperBox {
  margin-left: 0.3rem;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
  padding-bottom: 0.2rem;
  border-bottom: 1px solid #e5e5e5;
}
.swiperTicket {
  width: 1.8rem;
  height: 2.18rem;
  background-image: url(../assets/ticket01.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-top: 0.1rem;
}
.swiperTicket > div {
  text-align: center;
}
.ticketMoney {
  line-height: 0.68rem;
  font-size: 0.5rem;
  color: #4a0300;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.ticketMoney > span:nth-child(1) {
  font-size: 0.24rem;
  line-height: 0.6rem;
}
.useGoodMust,
.useMust {
  background: #fcd4d2;
  font-size: 0.22rem;
  color: #cc1a1a;
  margin: 0 0.1rem;
  border-radius: 0.2rem;
  height: 0.34rem;
  line-height: 0.34rem;
  overflow: hidden;
  /*不换行*/
  white-space: nowrap;
  /*添加...*/
  text-overflow: ellipsis;
}
.useMust {
  padding: 0 0.05rem;
}
.ticketType {
  font-size: 0.22rem;
  color: #724f4d;
  line-height: 0.37rem;
  padding-top: 0.08rem;
  margin: 0 0.1rem;
  // border-bottom: 1px dashed #E7786F
}
.ticketClick {
  font-size: 0.28rem;
  line-height: 0.6rem;
  color: #c91111;
}
.noShop {
  height: 100vh;
  width: 100%;
  text-align: center;
  line-height: 0.8rem;
  padding-top: 0.2rem;
}
</style>
